import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { WorkflowV1 } from "../shared/interfaces/WorkflowV1";
export function useWorkflows(
  customerId?: number,
  companyId?: number,
  siteId?: number,
  callbacks?: QueryCallbacks<WorkflowV1[]>,
) {
  const apiContext = useContext(ApiContext);

  var key = "workflowsByCustomer";

  if (customerId && companyId && siteId) key = "workflowsByCustomerAndSite";
  else if (customerId && companyId) key = "workflowsByCustomerAndCompany";

  return useQuery({
    queryKey: [key, customerId, companyId, siteId],
    queryFn: async () => {
      if (customerId && companyId && siteId)
        return await apiContext.workflowApis.getWorkflowsByCustomerAndSite(customerId, siteId);
      else if (customerId && companyId)
        return await apiContext.workflowApis.getWorkflowsByCustomerAndCompany(customerId, companyId);
      else if (customerId) return await apiContext.workflowApis.getWorkflowsByCustomer(customerId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
